export const FLIGHT_LEVEL = 350;
/** Minimum axis span when aircraft and crossing are very close together */
export const MIN_VIEW_SPAN_NM = 12;
/** Extra world-space margin for labels and QDM readouts */
export const VIEW_MARGIN_NM = 8;
export const VIEW_PADDING_FACTOR = 1.12;
export const AIRCRAFT_LABEL_GAP_PX = 15;
export const AIRCRAFT_LABEL_OFFSET_Y_PX = -15;
export const AIRCRAFT_LABEL_WIDTH_PX = 95;
export const AIRCRAFT_LABEL_HEIGHT_PX = 42;
export const QDM_LABEL_GAP_PX = 10;
export const QDM_LABEL_HEIGHT_PX = 18;
export const QDM_LABEL_CHAR_WIDTH_PX = 6.5;
export const AIRCRAFT_LABEL_NUDGE_STEP_PX = 22;
export const LABEL_OVERLAP_PAD_PX = 4;
export const TOTAL_PROBLEMS = 5;
/** Max points per level: realistic levels 1-5, with a gentle difficulty ramp (sum = 100) */
export const MAX_SCORE_BY_LEVEL = [16, 18, 20, 22, 24];
/** Full-points error tolerance in NM for each level */
export const PERFECT_ERROR_BY_LEVEL = [1, 1.125, 1.25, 1.375, 1.5];
export const TIME_CHALLENGE_DURATION_MS = 120000;
export const TIME_CHALLENGE_SEED_VERSION = 1;
export const SLIDER_CENTER = 15;
export const SLIDER_MAX = 30;
export const CROSSING_HIT_RADIUS_PX = 32;

export const MeasurementStep = {
    CROSSING: 'crossing',
    AIRCRAFT: 'aircraft',
    DONE: 'done',
};

export const DIFFICULTY_COLORS = [
    '#4ade80', '#4ade80', '#6ee7b7', '#a7f3d0',
    '#facc15',
];

export const CALLSIGN_LIST = [
    'ACA', 'AEE', 'AFL', 'AFR', 'AMC', 'ASL', 'AUA', 'AUI', 'AZA', 'BAW',
    'BEL', 'BRU', 'BTI', 'CCA', 'CES', 'CFG', 'CTN', 'CSN', 'CLX', 'DAH',
    'DAL', 'DLA', 'DLH', 'EJU', 'ELY', 'ETD', 'ETH', 'EWG', 'EXS', 'EZS',
    'EZY', 'FDX', 'FIN', 'IBE', 'KAL', 'KLM', 'LGL', 'LOT', 'LZB', 'MEA',
    'MGX', 'MLD', 'MSR', 'NAX', 'PGT', 'QTR', 'RJA', 'RYR', 'SAS', 'SBI',
    'SVA', 'SWR', 'SXD', 'SXS', 'TAP', 'TAR', 'TDR', 'THA', 'THY', 'TOM',
    'TRA', 'TVF', 'TVS', 'UAE', 'UAL', 'VLG', 'VOE', 'WUK', 'WZZ',
];
